import { Http } from "@/plugins/http.js";
import dayjs from "dayjs";
import { buildAvailableSchedules } from "@/modules/schedule/schedule.utils.js";

class Repository {
  #http = null;

  /**
   * @param {import("axios").AxiosInstance} http
   */
  constructor(http) {
    this.#http = http;
  }

  /**
   * @param {number} doctorId
   * @param {Object} params
   * @returns {Promise<{schedules: Object, week: number, weekInfo: Object}|null>}
   */
  async getCalendar(doctorId, params = {}) {
    try {
      const { data } = await this.#http.get(`v1/doctors/${doctorId}/schedule-daily/${params.date || ""}`, {
        params: {
          week: params.week,
          week_type: params.weekType,
        },
      });

      return {
        schedules: data.schedules
          ? buildAvailableSchedules(data.schedules)
          : { [dayjs(params.date).format("DD.MM.YYYY")]: { items: Object.values(data) } },
        week: data.week,
        weekInfo: data.week_info,
      };
    } catch (e) {
      console.log("ScheduleRepository.getCalendar", e.response);
    }

    return null;
  }

  /**
   * @param {number} doctorId
   * @param {number} customerId
   * @param {string} startAt
   * @param {number} duration
   * @param {number} providingWayId
   * @param {string|null} eventId
   * @returns {Promise<any>}
   */
  async appointment(doctorId, customerId, startAt, duration, providingWayId, eventId, additionalDoctors) {
    try {
      const response = await this.#http.post(`v1/appointments`, {
        doctor_id: doctorId,
        customer_id: customerId,
        start_at: dayjs(startAt).format("YYYY-MM-DD HH:mm"),
        duration: duration,
        providing_way: providingWayId,
        event_id: eventId,
        additional_doctors: additionalDoctors,
      });
      return { success: response.data.success, message: response.data.message };
    } catch (e) {
      console.log("ScheduleRepository.getCalendar", e.response);
      return { success: false, message: e.response.data.message };
    }
  }

  /**
   * @returns {Promise<{success: boolean, message: string}>}
   */
  async cancelAppointment(entityId) {
    try {
      const response = await this.#http.delete(`v1/appointments/${entityId}`);
      return { success: response.data.success, message: response.data.message };
    } catch (e) {
      console.log("ScheduleRepository.cancelAppointment", e.response);
      return { success: false, message: e.response.data.message };
    }
  }
  /**
   * @returns {Promise<{success: boolean, message: string}>}
   */
  async getAppointment(entityId) {
    try {
      const response = await this.#http.get(`v1/appointments/${entityId}`);
      console.log(`response =>`, response);
      if (response.status === 200) {
        return { success: true, data: response.data };
      }
    } catch (e) {
      console.log("ScheduleRepository.getAppointment", e.response);
      return { success: false, message: e.response.data.message };
    }
  }
}

const ScheduleRepository = new Repository(Http);

export { ScheduleRepository };
